<template>
  <section v-if="!error" class="faq">
    <h3 v-if="!disableTitle" class="title">{{ title_ }}</h3>
    <Loader v-if="isLoading" />
    <div v-else class="faq__accordion">
      <LandingFaqItem
        v-for="faq of filteredFaqLandingList"
        :key="faq.SortOrder"
        @clickHeaderFaq="expanded => handleTapFAQ(faq, expanded)"
      >
        <template v-slot:header>
          {{ faq.question || faq.Question }}
        </template>
        <template v-slot:content>
          <p v-html="faq.answer || faq.Answer"></p>
        </template>
      </LandingFaqItem>
    </div> <!-- accordion -->
    <a href="#" class="btnSecond" v-if="showButton" @click.prevent="showMore">
      {{$t('qic_landing_show_more_faq')}}
      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5 5C13.5 4.44772 13.0523 4 12.5 4C11.9477 4 11.5 4.44772 11.5 5V16.5858L6.20711 11.2929C5.81658 10.9024 5.18342 10.9024 4.79289 11.2929C4.40237 11.6834 4.40237 12.3166 4.79289 12.7071L11.7578 19.7071C11.9553 19.9046 12.2237 20.0022 12.4914 20C12.4942 20 12.4971 20 12.5 20C12.7765 20 13.0268 19.8878 13.2078 19.7064L20.2071 12.7071C20.5976 12.3166 20.5976 11.6834 20.2071 11.2929C19.8166 10.9024 19.1834 10.9024 18.7929 11.2929L13.5 16.5858V5Z" fill="#5927FF"/>
      </svg>
    </a>
  </section>
</template>

<script>
import LandingFaqItem from './LandingFaqItem.vue'
import httpClient from '@/plugins/axios'
import Loader from '../Loader'
export default {
  name: 'LandingFaq',
  props: {
    faqList: { type: Array, default: () => [] },
    categoryID: { type: Number, default: null },
    title: { type: String },
    faqHeaderKey: { type: String, default: 'header' },
    faqContentKey: { type: String, default: 'content' },
    disableTitle: { type: Boolean, default: false }
  },
  components: {
    LandingFaqItem,
    Loader
  },
  data () {
    return {
      isLoading: false,
      showAll: false,
      startFaqNum: 8,
      faqLandingList: [],
      error: false
    }
  },
  watch: {
    faqList () {
      this.faqLandingList = this.faqList
      this.isLoading = false
    }
  },
  computed: {
    filteredFaqLandingList () {
      const list = [...this.faqLandingList]
      list?.sort((a, b) => a.SortOrder - b.SortOrder)
      if (list.length > this.startFaqNum && !this.showAll) {
        return list.slice(0, this.startFaqNum - 1)
      }
      return list
    },
    title_ () {
      return this.title || this.$t('qic_landing_faq_header')
    },
    showButton () {
      return (this.faqLandingList.length > this.startFaqNum) && !this.showAll
    }
  },
  methods: {
    async getFaqs () {
      if (!this.categoryID) return

      try {
        this.isLoading = true

        const faqs = await httpClient.get(`getfaqs?CategoryID=${this.categoryID}`)
        this.faqLandingList = faqs.data.FAQs || []
      } catch (e) {
        console.log('getFaqs error: ', e)
      } finally {
        this.isLoading = false
        this.error = !this.faqLandingList?.length
      }
    },
    showMore () {
      this.showAll = true
      this.$emit('showMore')
    },
    handleTapFAQ (faq, expanded = false) {
      const text = faq.question || faq.Question
      this.$emit('headerClick', {
        expanded,
        text
      })
    }
  },
  mounted () {
    if (!this.categoryID && !this.faqList?.length) {
      this.isLoading = true
    }

    if (this.faqList?.length) {
      this.faqLandingList = this.faqList
    } else {
      this.getFaqs()
    }
  }
}
</script>
